"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.resolveFormat = exports.isDateEnabled = exports.isDateBetween = void 0;

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _constants = require("./constants");

var _moment = _interopRequireDefault(require("moment"));

var isDateBetween = function isDateBetween(_ref) {
  var date = _ref.date,
      dateTuple = _ref.dateTuple,
      format = _ref.format,
      isRangeEnabled = _ref.isRangeEnabled;

  var _ref2 = dateTuple || [],
      _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      start = _ref3[0],
      end = _ref3[1];

  if (typeof start === 'undefined' || typeof end === 'undefined') {
    return false;
  }

  var startMoment = (0, _moment.default)(start, format);
  var endMoment = (0, _moment.default)(end, format); // It's possible to switch tuple so the first value is after the second value

  if (isRangeEnabled && startMoment.isAfter(endMoment)) {
    return endMoment.isSameOrBefore(date) && startMoment.isSameOrAfter(date);
  }

  return startMoment.isSameOrBefore(date, 'day') && endMoment.isSameOrAfter(date, 'day');
};

exports.isDateBetween = isDateBetween;

var isWeekdayDisabled = function isWeekdayDisabled(date, disableWeekday) {
  if (!disableWeekday) {
    return false;
  }

  var daysName = _moment.default.weekdays();

  return (0, _indexOf.default)(disableWeekday).call(disableWeekday, daysName[date.day()]) > -1;
};

var isDateEnabled = function isDateEnabled(day, _ref4) {
  var dateFormat = _ref4.dateFormat,
      disableWeekends = _ref4.disableWeekends,
      disableAfterDate = _ref4.disableAfterDate,
      disableBeforeDate = _ref4.disableBeforeDate,
      disableWeekday = _ref4.disableWeekday,
      disablePastDates = _ref4.disablePastDates,
      disableFutureDates = _ref4.disableFutureDates,
      disabledDates = _ref4.disabledDates,
      disabledDateRanges = _ref4.disabledDateRanges,
      locale = _ref4.locale;
  var format = resolveFormat({
    dateFormat: dateFormat,
    locale: locale
  });
  return !isWeekdayDisabled(day, disableWeekday) && !(disableWeekends && (day.day() === 0 || day.day() === 6)) && !(disableBeforeDate && day.isBefore((0, _moment.default)(disableBeforeDate, format), 'day')) && !(disableAfterDate && day.isAfter((0, _moment.default)(disableAfterDate, format), 'day')) && !(disablePastDates && day.isBefore((0, _moment.default)(), 'day')) && !(disableFutureDates && day.isAfter((0, _moment.default)(), 'day')) && !(0, _some.default)(disabledDates).call(disabledDates, function (date) {
    return (0, _moment.default)(date, format).diff(day, 'days') === 0;
  }) && !(0, _some.default)(disabledDateRanges).call(disabledDateRanges, function (dateTuple) {
    return isDateBetween({
      date: day,
      dateTuple: dateTuple,
      format: format
    });
  });
};

exports.isDateEnabled = isDateEnabled;

var resolveFormat = function resolveFormat(_ref5) {
  var dateFormat = _ref5.dateFormat,
      locale = _ref5.locale;

  if (dateFormat) {
    return dateFormat;
  } else if (locale) {
    var localeData = _moment.default.localeData(locale);

    return localeData.longDateFormat('L');
  }

  return _constants.ISO_DATE_FORMAT;
};

exports.resolveFormat = resolveFormat;